<template>
        <div class="column">
            <div class="field is-horizontal">
                <div class="field-body">
                    <div class="field-label is-normal">
                        <label class="label">Condition</label>
                    </div>
                    <div class="field is-narrow">
                        <div class="control">
                            <div class="select is-fullwidth">
                                <select v-model="condition" :disabled="isLocked">
                                        <option value="100">100%</option>
                                        <option value="50">50%/50%</option>
                                        <option value="30">30%/70%</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="field is-narrow">
                        <div class="control">
                            <div class="select is-fullwidth" :class="{'is-danger' : proformaInvoiceValidationErrors.incoterm }">
                                <select v-model="incoterm" :disabled="isLocked">
                                    <option value="0">Incoterm</option>
                                    <option value="1">FOB</option>
                                    <option value="2">CIF</option>
                                    <option value="3">C&F</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="field-label is-normal">
                        <label class="label">Currency</label>
                    </div>
                    <div class="field is-narrow">
                        <div class="control">
                            <div class="select is-fullwidth">
                                <select v-model="currency" disabled>
                                    <option value="1">¥ (JPY)</option>
                                    <option value="2">$ (USD)</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="field-label is-normal">
                        <label class="label">Rate</label>
                    </div>
                    <div class="field">
                        <div class="field has-addons">
                            <p class="control">
                                <a class="button is-static">
                                    <i class="fas fa-dollar-sign"></i>
                                </a>
                            </p>
                            <p class="control" style="max-width: 100px">
                                <input class="input" type="number" :value="rate" :disabled="isLocked" readonly>
                            </p>
                        </div>
                    </div>
                    <div class="field-label is-normal">
                        <label class="label">Client</label>
                    </div>
                    <div class="field is-expanded">
                        <div class="field has-addons">
                            <p class="control">
                                <a class="button is-static">
                                    <i class="fas fa-user"></i>
                                </a>
                            </p>
                            <p class="control is-expanded">
                                <input class="input" :value="car.user.name" placeholder="Client details" :disabled="isLocked" readonly>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Remarks</label>
                </div>
                <div class="field is-expanded remarks">
                    <div class="field has-addons">
                        <p class="control">
                            <a class="button is-static">
                                <i class="fas fa-car"></i>
                            </a>
                        </p>
                        <p class="control remarks">
                            <input class="input" :disabled="isLocked" v-model="remarks" placeholder="Cars remarks">
                        </p>
                    </div>
                </div>
                <div class="field-label is-normal">
                    <label class="label">Details</label>
                </div>
                <div class="field is-expanded">
                    <p class="control has-icons-left">
                        <span class="select">
                           <select v-model="invoiceDetailsId" style="max-width: 150px;" :disabled="isLocked">
                              <option :value="null" disabled>Select Invoice Details</option>
                              <option v-for="detail in invoiceDetails" :value="detail.id">{{ detail.name }}, {{ detail.city }}</option>
                           </select>
                        </span>
                        <span class="icon is-small is-left">
                           <i class="fas fa-globe"></i>
                        </span>
                    </p>
                </div>
                <div class="field-label is-normal">
                    <label class="label">Deposit</label>
                </div>
                <div class="field is-expanded">
                    <div class="field has-addons">
                        <p class="control">
                            <a class="button is-static">
                                <i v-if="isInUsd" class="fas fa-dollar-sign"></i>
                                <i v-else="" class="fas fa-yen-sign"></i>
                            </a>
                        </p>
                        <p class="control is-expanded">
                            <input class="input" type="number" :value="car.user.balance.amount" placeholder="Client deposit" :disabled="isLocked" readonly>
                        </p>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
    import apiInvoiceContactDetails from '../../../../api/apiInvoiceContactDetails'
    export default {
        props:['car'],
        components: {

        },
        data () {
            return {
                invoiceDetails: []
            }
        },
        computed: {
            proformaInvoiceValidationErrors() {
                return this.$store.getters.getProformaInvoiceValidationErrors
            },
            isLocked() {
                return this.$store.getters.getProformaInvoiceLockedStatus
            },
            rate() {
                return this.$store.getters.getProformaInvoice.rate
            },
            condition: {
                get() {
                    return this.$store.getters.getProformaInvoice.condition
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceFieldValue', {field: 'condition', value: value })
                }
            },
            incoterm: {
                get() {
                    return this.$store.getters.getProformaInvoice.incoterm
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceFieldValue', {field: 'incoterm', value: value })
                }
            },
            currency: {
                get() {
                    return this.$store.getters.getProformaInvoice.currency
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceFieldValue', {field: 'currency', value: value })
                }
            },
            invoiceDetailsId: {
                get() {
                    return this.$store.getters.getProformaInvoice.invoice_details_id
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceFieldValue', {field: 'invoice_details_id', value: value })
                }
            },
            client() {
                return this.$store.getters.getProformaInvoice.client
            },
            remarks: {
                get() {
                    return this.$store.getters.getProformaInvoice.remarks
                },
                set(value) {
                    this.$store.dispatch('changeProformaInvoiceFieldValue', {field: 'remarks', value: value })
                }
            },
            isInUsd() {
                return this.currency == 2 // 2 stands
            }
        },
        mounted() {
            apiInvoiceContactDetails
                .invoiceContactDetailsListRequest(this.car.user_id)
                .then((response) => {
                    this.invoiceDetails = response.data
                })
                .catch((error) => console.log(error))
        }
    }
</script>

<style scoped>
    .field-label {
        flex-grow: 0;
    }
    .field-label .label {
        font-size: medium !important;
    }
    .remarks {
        width: 93%;
    }
    .label {
        white-space: nowrap;
        min-width: 100px;
    }
    .is-static {
        min-width: 50px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Cars/Columns/ProformaInvoice/ProformaInvoiceSettings.vue